import { useNavigate } from 'react-router-dom'

import { formatLocation } from '../../routes'
import { FirstArgument } from '../../utils/type-utils'

export const goToTask = (
  history: ReturnType<typeof useNavigate>,
  props: FirstArgument<typeof formatLocation['task']>,
) => void history(formatLocation.task(props))
